module.exports = __webpack_public_path__ + "img/HYUNDAI.eb9024d.jpg";